import { createStore, applyMiddleware } from "redux";
import { reducers } from "../reducer";
import thunk from "redux-thunk";
import routers from "routes/routes";
import { Toast } from "service/helpers/toast";
import moment from "moment";
import CryptoJS from "crypto-js";

export const store = createStore(
  reducers,
  applyMiddleware(thunk.withExtraArgument({ Toast }))
);
export const history = require("history").createBrowserHistory({});

let routerCache = {},
  timer;

export const pageNavigationByName = (locationDetails) => {
  let { name: locationName, params = "", ...rest } = locationDetails;

  let pathname = "";

  let locationProps = rest || {};

  if (routerCache.hasOwnProperty(locationName)) {
    pathname = routerCache[locationName];
  } else {
    for (let i = 0; i < routers.length; i++) {
      let { name = "", childrens = [], path: parentPath } = routers[i];

      if (name === locationName) {
        pathname = parentPath;
        routerCache[locationName] = parentPath;
        break;
      } else {
        for (let j = 0; j < childrens.length; j++) {
          let { name = "", path = "" } = childrens[j];

          if (name === locationName) {
            let fullPath = `${parentPath}${path}`;
            pathname = fullPath;
            routerCache[locationName] = fullPath;
            break;
          }
        }
      }

      if (pathname) break;
    }
  }

  if (params) {
    pathname = Object.keys(params).reduce((acc, keyName) => {
      return acc.replace(`:${keyName}`, params[keyName]);
    }, pathname);
  }

  history.push({ pathname, ...locationProps });
};

export const getMonth = (month) => {
  switch (month) {
    case "Jan":
      return 0;
    case "Feb":
      return 1;
    case "Mar":
      return 2;
    case "Apr":
      return 3;
    case "May":
      return 4;
    case "Jun":
      return 5;
    case "Jul":
      return 6;
    case "Aug":
      return 7;
    case "Sep":
      return 8;
    case "Oct":
      return 9;
    case "Nov":
      return 10;
    case "Dec":
      return 11;
    default:
      return 1;
  }
};

export const dateDiff = (orderStartDate, orderEndDate = false) => {
  let finalValue;

  let currentDate = moment([
    new Date().getFullYear(),
    new Date().getMonth(),
    new Date().getDate(),
  ]);

  let startDate = moment([
    String(orderStartDate).split(",")[0].split(" ")[2],
    getMonth(String(orderStartDate).split(",")[0].split(" ")[1]),
    String(orderStartDate).split("th")[0],
  ]);

  let endDate = moment([
    String(orderEndDate).split(",")[0].split(" ")[2],
    getMonth(String(orderEndDate).split(",")[0].split(" ")[1]),
    String(orderEndDate).split("th")[0],
  ]);

  if (orderEndDate) {
    finalValue = endDate.diff(startDate, "days");
  } else {
    finalValue = currentDate.diff(startDate, "days");
  }

  return finalValue > 1 ? `${finalValue} days` : `${finalValue} day`;
};

export const isGeneralImage = (data) => {
  let urls = [];
  data.items.map((list) => {
    list.imgUrls.map((url) => {
      urls.push(url);
    });
  });
  let isGeneral = urls.some((list) => {
    return String(list).includes("General+New");
  });
  return isGeneral ? "Yes" : "No";
};

export const getFirstLetter = (value) => {
  if (!value) return;
  if (Array.isArray(value)) {
    let letter = "",
      lastIndex = value?.length - 1;

    if (value?.length <= 0) return;
    if (value[0]) letter += value[0]?.charAt(0)?.toUpperCase();
    if (lastIndex && value[lastIndex])
      letter += value[lastIndex]?.charAt(0)?.toUpperCase();

    return letter;
  }
  return value?.charAt(0).toUpperCase();
};

export const debounceFunction = (fn, delay) => {
  let timeoutID;
  return (...args) => {
    if (timeoutID) clearTimeout(timeoutID);
    timeoutID = setTimeout(() => {
      fn(...args);
    }, delay);
  };
};



export const Hours = [
  "12",
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
];

export const Minutes = [
  "00",
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
  "31",
  "32",
  "33",
  "34",
  "35",
  "36",
  "37",
  "38",
  "39",
  "40",
  "41",
  "42",
  "43",
  "44",
  "45",
  "46",
  "47",
  "48",
  "49",
  "50",
  "51",
  "52",
  "53",
  "54",
  "55",
  "56",
  "57",
  "58",
  "59",
];

export const Types = ["AM", "PM"];

export const timeConvert = (time) => {
  // Check correct time format and split into components
  time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [
    time,
  ];

  if (time.length > 1) {
    // If time format correct
    time = time.slice(1); // Remove full string match value
    time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
    time[0] = +time[0] % 12 || 12; // Adjust hours
  }
  return time.join(""); // return adjusted time or original string
};

export const handleFileChange = (event, onChange, func) => {
  console.log(event, "check event")
  const file = event.target?.files[0] || event;
  console.log(file, "filefile")
  if (!file) {
    return;
  }

  const reader = new FileReader();

  reader.onload = (e) => {
    const content = e.target.result;
    // Check for SVG markers
    const isSvg = content.trim().startsWith('<svg') || content.trim().startsWith('<?xml');
    if (isSvg) {
      console.log('The file is an SVG.');
      Toast({
        type: "error",
        message: "SVG Not Allowed"
      })

    } else {
      func()
      // imageHandler(event, onChange);

      console.log('The file is NOT an SVG.');
    }
  };

  reader.onerror = () => {
    console.log('Error reading the file.');
    Toast({
      type: "error",
      message: "Error with file"
    })
  };

  reader.readAsText(file); // Read the file as text
};
export const Encrypt = (plainText) => {
  if (!plainText) {
    return plainText;
  }
  try {
    var ciphertext = CryptoJS.AES.encrypt(
      plainText,
      "39ib92v7db292bbwqddhvsi73tw048dbi3h8hf4b9cib49"
    ).toString();

    return ciphertext;
  } catch (e) {
    console.log("Error in encryption", e);
    return plainText;
  }
};

export const findHour = (start, end) => {
  if (start && end) {
    var startTimeString = start;
    var endTimeString = end;

    // Convert time strings to Date objects (assuming today's date)
    var startDate = new Date("1970-01-01T" + startTimeString + ":00");
    var endDate = new Date("1970-01-01T" + endTimeString + ":00");

    // Calculate the time difference in milliseconds
    var timeDifference = endDate - startDate;

    // Convert time difference to minutes
    var differenceInMinutes = timeDifference / (1000 * 60);
    console.log("Difference in minutes:", differenceInMinutes);
    return differenceInMinutes;

  }
};

export const debounce =
  (func, setLoading, timeout = 800) =>
    (...args) => {
      clearTimeout(timer);
      timer = setTimeout(async () => {
        typeof setLoading === "function" && setLoading(true);
        await func(...args);
        typeof setLoading === "function" && setLoading(false);
      }, [timeout]);
    };

export const permissions = () => {
  let screen = window.screen.width
  let permission = {

  }
  if (screen < 601) {
    permission.add = true
    permission.update = true
    permission.view = true

  } else {
    permission.add = true
    permission.update = true
    permission.view = true
  }


  return permission

}

export const calculateMedicineQuantity = ({
  durationUnit,
  gapBetweenDose,
  frequencyUnit,
  dose,
  duration,
}) => {
  // Define mapping for duration units
  const durationUnitMap = {
    MONTHS: 30,
    WEEKS: 7,
    DAYS: 1,
    AS_REQUIRED: 30,
  };

  // Define mapping for gap between doses
  const gapBetweenDoseMap = {
    "24_HOURS": 1,
    "12_HOURS": 2,
    "8_HOURS": 3,
    "6_HOURS": 4,
    "5_HOURS": 5,
    "4_HOURS": 6,
    SOS: 1,
  };

  // Define mapping for frequency units
  const frequencyUnitMap = {
    DAILY: 1,
    WEEKLY: 7,
    BIWEEKLY: 14,
    MONTHLY: 30,
    SOS: 1,
  };

  // Calculate values based on provided inputs
  const medValue = durationUnitMap[durationUnit] || 0;
  const gapValue = gapBetweenDoseMap[gapBetweenDose] || 0;
  const freqOrigValue = frequencyUnitMap[frequencyUnit] || 0;
  const doseValue = typeof dose === "string" ? parseFloat(dose.replace(/[^\d.]/g, "")) : dose || 0; // Remove non-numeric characters
  const durationValue = duration || 0;

  // Calculate the prescribed quantity
  let quantityPrescribed = 0;
  if (frequencyUnit === "DAILY") {
    quantityPrescribed =
      medValue * gapValue * doseValue * durationValue;
  } else {
    quantityPrescribed =
      gapValue * doseValue * durationValue * (medValue / freqOrigValue);
  }

  return quantityPrescribed;
};
export const callAndVideoIconAvailability = (tenantData, appointmentData) => {
  if (!appointmentData) {
    return {
      audio: false,
      video: false
    }
  }
  console.log(tenantData?.modeOfConsult, "mode consult")
  let defaultStatus = {
    audio: true,
    video: true
  }
  let contstant = { both: "both", video: "video", audio: "audio" }
  console.log(appointmentData?.modeOfConsult, "appointmentData?.modeOfConsult")
  
  switch (appointmentData?.modeOfConsult || tenantData?.modeOfConsult) {
    case "both":
      defaultStatus.audio = true
      defaultStatus.video = true
      break;

    case "video":
      defaultStatus.video = true
      defaultStatus.audio = false

      break;

    case "audio":
      defaultStatus.video = false
      defaultStatus.audio = true
      break;

    default:
      defaultStatus.video = true
      defaultStatus.audio = true
      break;
  }
  console.log(defaultStatus, "defaultStatus")
  return defaultStatus
}
permissions()